/* src/app/account/user-settings/user-settings.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.user-settings,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.user-settings {
  position: relative;
}
.user-settings .form-body,
.user-settings .form-footer {
}
@media screen and (min-width: 48rem) {
  .user-settings .form-body .mat-form-field-type-mat-input,
  .user-settings .form-footer .mat-form-field-type-mat-input {
    width: 50%;
  }
}
@media screen and (min-width: 64rem) {
  .user-settings .form-body .mat-form-field-type-mat-input,
  .user-settings .form-footer .mat-form-field-type-mat-input {
    width: 30%;
  }
}
@media screen and (min-width: 64rem) {
  .user-settings .form-footer {
    width: 50%;
  }
}
.user-settings .deprecated-key-values {
  width: 100%;
}
.user-settings .deprecated-key-values .key-value {
  width: 100%;
}
.user-settings .deprecated-key-values .key-value .value {
  white-space: initial;
  width: auto;
}
.user-settings .deprecated-key-values .key-value .value a {
  margin: 0 0.5em;
}
.user-settings .form-section.user-profile,
.user-settings .form-section.change-password {
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .user-settings .form-section.user-profile,
  .user-settings .form-section.change-password {
    width: 20rem;
  }
}
.fixedtable {
  table-layout: fixed;
  min-width: 800px;
}
.trimResponse {
  overflow: hidden;
  color: var(--UPS-Brand-Colors-UPS-Black, #121212);
  font-feature-settings: "liga" off, "clig" off;
  text-overflow: ellipsis;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: inline-block;
  width: 90%;
}
.trimheader {
  max-width: 200px;
}
.setMargin {
  margin-bottom: -0.3rem !important;
}
.rules {
  font-size: 0.875em;
  padding: 0 23px;
  line-height: 1.57;
  margin: 0.8125rem 0 1.6875rem;
}
@media screen and (min-width: 48rem) {
  .rules {
    padding: 0 32px;
  }
}
:host::ng-deep .dataTables_wrapper {
  padding: 0 0;
}
/*# sourceMappingURL=user-settings.component.css.map */
